import React, { useEffect, useState, useRef } from "react";
import qs from "qs";
import moment from "moment";
import { findDOMNode } from "react-dom";
import screenfull from "screenfull";
import Duration from "./parts/duration";
import ReactPlayer from "react-player";

require("moment/min/locales");
moment.locale("it");

const dateFormat = "dddd DD MMMM YYYY - HH:mm";
const playIcon =
  "https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/playIcon.svg";
const pauseIcon =
  "https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/pauseIcon.svg";

const Player2 = (props) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentProgress, setCurrentProgress] = useState(0);
  const [currentSeconds, setCurrentSeconds] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [mouseMoving, setMouseMoving] = useState(true);
  const userId = qs.parse(props.location.search, {
    ignoreQueryPrefix: true,
  }).userId;
  const idContent = qs.parse(props.location.search, {
    ignoreQueryPrefix: true,
  }).idContent;
  const [currentContent, setCurrentContent] = useState();
  const [imgUser, setImgUser] = useState("");
  const containerPlayer = useRef();
  const player = useRef();
  const [isFullScreen, setIsFullscreen] = useState(false)

  const fetchData = async () => {
    await fetch("https://api.peperoni.ai/core/pep-core/user/" + userId)
      .then((response) => response.json())
      .then((data) => setImgUser(data.results.avatar));
    await fetch(
      "https://api.peperoni.ai/contents/pep-contents/" +
        userId +
        "/content/" +
        idContent
    )
      .then((response) => response.json())
      .then((data) => setCurrentContent(data.content));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlePlay = () => {
    setIsPlaying(!isPlaying);
  };

  const handleDuration = (duration) => {
    setDuration(duration);
  };

  const handleProgress = (state) => {
    setCurrentProgress(state.played * 100);
    setCurrentSeconds(state.playedSeconds);
  };

  const handleFullscreen = () => {
    screenfull.toggle(findDOMNode(containerPlayer.current));
  };

  const changeTime = (e) => {
    setIsPlaying(false);
    var value = (duration * e.target.value) / 100;
    player.current.seekTo(parseFloat(value));
    setIsPlaying(true);
  };

  const prev10 = () => {
    if (currentSeconds > 10) {
      setIsPlaying(false);
      player.current.seekTo(parseFloat(currentSeconds - 10));
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
      player.current.seekTo(0);
      setIsPlaying(true);
    }
  };

  const next10 = () => {
    if (currentSeconds + 10 < duration) {
      setIsPlaying(false);
      player.current.seekTo(parseFloat(currentSeconds - 10));
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
      player.current.seekTo(duration - 1);
      setIsPlaying(true);
    }
  };

  const renderImage = () => {
    if (
      currentContent !== undefined &&
      currentContent.img_url !== undefined &&
      currentContent.img_url !== null
    ) {
      return currentContent.img_url;
    } else {
      if (imgUser !== null && imgUser !== "") {
        return imgUser;
      } else {
        return "https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/user_icon.png";
      }
    }
  };

  const setOpacityStatus = () => {
    if (opacity == 1) {
      setOpacity(0);
    } else {
      setOpacity(1);
    }
  };

  if (currentContent) {
    return (
      <div className="main">
        <div ref={containerPlayer}>
          {currentContent !== undefined && currentContent.video_url !== null ? (
            <div className="fullScreenMobile">
              <img
                src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/fullscreen-icon.png"
                onClick={() => handleFullscreen()}
              />
            </div>
          ) : (
            ""
          )}
          <ReactPlayer
            ref={player}
            className={
              currentContent !== undefined && currentContent.video_url !== null
                ? "playerVideo"
                : "playerAudio"
            }
            url={
              currentContent !== undefined && currentContent.video_url !== null
                ? currentContent.video_url
                : currentContent.audio_url
            }
            playing={isPlaying}
            onDuration={(d) => handleDuration(d)}
            onProgress={(p) => handleProgress(p)}
            onClick={() => setOpacityStatus()}
            controls={false}
          />
        </div>
        <div
          style={{opacity: opacity}}
          className={
            currentContent.video_url !== null
              ? "containerContent video"
              : "containerContent audio"
          }
        >
          <div
            className="overlayVideo"
            onClick={() => setOpacityStatus()}
          ></div>
          <div className="controls">
            <div
              className={
                currentContent.video_url !== null ? "coverVideo" : "coverAudio"
              }
            >
              <img src={renderImage()} onClick={() => handlePlay()} />
              <div className="overlayImage">
                <img
                  className="playIcon"
                  src={isPlaying ? pauseIcon : playIcon}
                  onClick={() => handlePlay()}
                />
              </div>
            </div>
          </div>
          <div className="mobileSection">
            <div
              className={
                currentContent.video_url !== null ? "cover-video" : "cover"
              }
            >
              <img src={renderImage()} onClick={() => handlePlay()} />
            </div>
            <div
              className={
                currentContent.video_url !== null ? "meta-video" : "meta"
              }
            >
              <div className="prevIcon">
                <img
                  src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/prev10.png"
                  onClick={() => prev10()}
                />
              </div>
              <div className="playContent">
                <img
                  className="playIcon"
                  src={isPlaying ? pauseIcon : playIcon}
                  onClick={() => handlePlay()}
                />
              </div>
              <div className="nextIcon">
                <img
                  src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/next10.png"
                  onClick={() => next10()}
                />
              </div>
            </div>
            <div
              className={
                currentContent.video_url !== null
                  ? "controlsMobile video"
                  : "controlsMobile"
              }
            >
              <h2 className="dateContent">
                {moment(currentContent.created_at).format(dateFormat)}
              </h2>
              <h1 className="titleContent">{currentContent.title}</h1>
              <input
                type="range"
                min="0"
                max="100"
                value={currentProgress}
                className="timeScroll"
                onInput={(e) => changeTime(e)}
                onChange={(e) => changeTime(e)}
              ></input>
              <p className="timeStart">
                <Duration seconds={currentSeconds} />
              </p>
              <p className="timeEnd">
                <Duration seconds={duration} />
              </p>
            </div>
          </div>
          <div className="controlBottom">
            <div className="controlPlayer">
              <input
                type="range"
                min="0"
                max="100"
                value={currentProgress}
                className="timeScroll"
                onInput={(e) => changeTime(e)}
                onChange={(e) => changeTime(e)}
              ></input>
              <p className="timeEnd">
                -{" "}
                <Duration
                  seconds={duration - currentSeconds}
                />
              </p>
            </div>
            <div className="playContent">
              <img
                className="playIcon"
                src={isPlaying ? pauseIcon : playIcon}
                onClick={() => handlePlay()}
              />
            </div>
            <div className="timeController">
              <img
                src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/prev10.png"
                onClick={() => prev10()}
              />
              <img
                src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/next10.png"
                onClick={() => next10()}
              />
            </div>
            {currentContent.video_url !== null ? (
              <div className="rightController">
                <img
                  src="https://22hbgtest.s3.eu-west-2.amazonaws.com/Peperoni/contents/general/fullscreen-icon.png"
                  onClick={() => handleFullscreen()}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="data">
            <h2 className="dateContent">
              {moment(currentContent.created_at).format(dateFormat)}
            </h2>
            <h1 className="titleContent">{currentContent.title}</h1>
            <p className="descriptionContent">{currentContent.description}</p>
          </div>
        </div>
      </div>
    );
  } else {
      return null
  }
};

export default Player2;
